import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BillingInformation } from '@pages/checkout/components';
import { buildStripeLocale } from '@global/utils/lang';
import { WpsPaymentForm } from '../WpsPaymentForm';
import { ReloadInitResponseContext } from '@src/pages/checkout/components/SecurePayment';

import { useAppSelector } from '@src/global/store/hooks';
import { cartSelector } from '@global/store/slices/cart/selectors';

import {
  PAYMENT_SUBMIT_BUTTON_ID,
  REACT_APP_WPS_DISABLE_CAPTCHA,
} from '@global/App/constants/constants';

import { WPSCustomEvent } from '../WpsPaymentForm/types';

import './style.scss';

interface CardProps {
  payment?: Record<string, unknown>;
}

const Card: React.FC<CardProps> = ({ payment }) => {
  const { paymentInitData, setPayment, setPaymentErr, paymentErr } = useContext(
    ReloadInitResponseContext
  );

  const cartState = useAppSelector(cartSelector);
  const { t } = useTranslation('');

  const locale = buildStripeLocale();
  const checkoutStep = 1;

  const handleOnSuccess = (
    wpsPaymentData: WPSCustomEvent['detail']['success']
  ) => {
    setPayment(wpsPaymentData);
  };

  const handleOnError = (err: WPSCustomEvent['detail']['error']) => {
    const errorMessage =
      err.returnMessage || t('checkout.step2.validationErr.unableProcess');
    setPaymentErr(errorMessage);
  };

  return (
    <>
      <BillingInformation
        isLoading={cartState.isLoading}
        checkoutStep={checkoutStep}
        buttonId={PAYMENT_SUBMIT_BUTTON_ID}
        payment={payment}
        paymentFormError={paymentErr}
      />
      {paymentErr && <p className="payment-form__error-msg">{paymentErr}</p>}
      <div className="card-wrapper" id="payment-form-anchor">
        {paymentInitData.appId && (
          <WpsPaymentForm
            onSuccess={handleOnSuccess}
            onError={handleOnError}
            appId={paymentInitData.appId}
            amount={paymentInitData.amount}
            currency={paymentInitData.currency}
            email={paymentInitData.email}
            intentType={paymentInitData.intentType}
            paymentReference={paymentInitData.paymentReference}
            paymentToken={paymentInitData.paymentToken}
            region={paymentInitData.region}
            timestamp={paymentInitData.timestamp}
            locale={locale}
            buttonId={PAYMENT_SUBMIT_BUTTON_ID}
            disableCaptcha={REACT_APP_WPS_DISABLE_CAPTCHA}
          />
        )}
      </div>
    </>
  );
};

export default Card;
